<template>
    <v-dialog id="error-dialog" v-model="dialog" max-width="420px">
        <v-card :style="fontStyle">
            <v-btn
                class="dialog__close"
                icon
                x-small
                @click.native="dialog = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>

            <v-card-text class="text-center">
                <font-awesome-icon
                    :icon="['fas', 'exclamation-triangle']"
                    class="mt-6 mb-3"
                    size="6x"
                    color="#ff5252"
                />

                <div class="custom-text-h6 mt-1">
                    {{ text }}
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import fontMixin from "@/mixins/fontMixin.js";

export default {
    name: "ErrorDialog",
    props: {
        text: String,
    },
    data() {
        return {
            dialog: false,
        };
    },
    mixins: [fontMixin],
    methods: {
        open() {
            this.dialog = true;
        },
    },
};
</script>
